// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmcbe9w1dm6X8CIZK78RgB8szbzM-3WIM",
  authDomain: "nippou-ipad.firebaseapp.com",
  projectId: "nippou-ipad",
  storageBucket: "nippou-ipad.appspot.com",
  messagingSenderId: "140514016835",
  appId: "1:140514016835:web:3808ea77ee069eb79c1ef6",
  measurementId: "G-K8EK085M9E",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export { auth, provider };
